<template>
  <div>
    <Message v-if="conexion.modoOffline" severity="warn" :closable="false">Sin conexión: solo se muestran las ventas pendientes de enviar y las enviadas desde este equipo.</Message>
    <DataTable :value="ventas" dataKey="uuid_venta" :rows="15" paginator class="p-datatable-sm" responsiveLayout="scroll" stripedRows>
      <!-- Etapa 3D (A): debajo de la fecha, «hace N h» en rojo si la venta sigue en cola con 60 h o más. Antes:
      <Column header="Fecha"><template #body="{ data }">{{ formatoFecha(data.fecha_venta_cliente) }}</template></Column> -->
      <Column header="Fecha"><template #body="{ data }">{{ formatoFecha(data.fecha_venta_cliente) }}
        <div v-if="esAntigua(data)" class="text-red-500 text-sm font-bold">hace {{ horasDe(data) }} h</div></template></Column>
      <Column header="Ref."><template #body="{ data }">{{ data.ticket.referencia }}</template></Column>
      <Column header="N.º local"><template #body="{ data }">{{ String(data.correlativo_local).padStart(4, '0') }}</template></Column>
      <Column header="Total" class="text-right"><template #body="{ data }">Bs. {{ Number(data.payload.total_cancelar).toFixed(2) }}</template></Column>
      <Column header="Método"><template #body="{ data }">{{ data.ticket.metodoPago }}</template></Column>
      <Column header="Estado">
        <template #body="{ data }">
          <span :class="claseEstado(data)" class="font-bold">{{ textoEstado(data) }}</span>
          <div v-if="data.venta_id" class="text-500 text-sm">Venta N.º {{ data.venta_id }}</div>
          <div v-if="data.estado === 'rechazada' || esError(data)" class="text-500 text-sm">{{ data.ultimo_error }}</div>
        </template>
      </Column>
      <Column header=""><template #body="{ data }"><Button icon="pi pi-print" class="p-button-text p-button-sm" v-tooltip.left="'Reimprimir'" @click="reimprimir(data)" /></template></Column>
    </DataTable>
  </div>
</template>

<script>
import { useConexion } from '@/stores';
import { listarCola } from '@/services-offline/colaVentas';
import { ticketAEscPosBase64 } from '@/helpers/ticketLocal';
import { useImpresora } from '@/composables/useImpresora';
import { AVISOS } from '@/config/offline';

// Etapa 3C: ventas guardadas en este equipo (sin las descartadas). Solo reimprimir: sin anular, editar ni devolver.
export default {
  name: 'ColaVentasLocal',
  setup() {
    const { imprimirBase64Local, imprimirTicketVentaBackend } = useImpresora();
    return { imprimirBase64Local, imprimirTicketVentaBackend };
  },
  data() {
    return { conexion: useConexion(), ventas: [] };
  },
  watch: {
    // Se recarga cada vez que cambian los contadores (sync, venta nueva)
    'conexion.ventasEnCola'() { this.cargar(); },
    'conexion.ventasRechazadas'() { this.cargar(); },
    'conexion.sincronizando'() { this.cargar(); }
  },
  mounted() {
    this.cargar();
  },
  methods: {
    async cargar() {
      this.ventas = await listarCola();
    },
    // Etapa 3D (A): horas desde la venta según la hora estimada del servidor
    horasDe(v) {
      return Math.floor((this.conexion.ahoraServidorMs() - Date.parse(v.fecha_venta_cliente)) / 3600000);
    },
    esAntigua(v) {
      return (v.estado === 'pendiente' || v.estado === 'enviando') && this.horasDe(v) >= AVISOS.horasVentaAntigua;
    },
    esError(v) {
      return v.estado === 'pendiente' && v.intentos > 0 && v.ultimo_error;
    },
    textoEstado(v) {
      if (v.estado === 'sincronizada') return 'Enviada';
      if (v.estado === 'rechazada') return 'Rechazada';
      if (this.esError(v)) return 'Error (se reintenta)';
      return 'Pendiente';
    },
    claseEstado(v) {
      if (v.estado === 'sincronizada') return 'text-green-600';
      if (v.estado === 'rechazada') return 'text-red-500';
      return 'text-orange-500';
    },
    formatoFecha(iso) {
      return new Date(iso).toLocaleString('es-BO');
    },
    async reimprimir(v) {
      // Enviada y con red: ticket del servidor; si no, el ticket local guardado
      if (v.estado === 'sincronizada' && v.venta_id && !this.conexion.modoOffline) {
        if (await this.imprimirTicketVentaBackend(v.venta_id)) return;
      }
      await this.imprimirBase64Local(ticketAEscPosBase64(v.ticket, v.estado));
    }
  }
};
</script>
